<template>
  <div class="form">
      <img :src="images.form">
      <div class="form-content">
          <input v-model.trim="name" type="text" class="name" placeholder="姓名*">
          <input v-model.trim="phone" type="text" class="phone" placeholder="电话*">
          <input v-model.trim="email" type="text" class="email" placeholder="邮箱*">
          <input v-model.trim="company" type="text" class="company" placeholder="公司*">
          <input v-model.trim="title" type="text" class="title" placeholder="职位*">
          <button :disabled="disabled" class="submit input" @click="apply">我要咨询<img v-show="loading" :src="images.loading" alt="" class="loading-img"/></button>
          <!-- <input :disabled="disabled" type="button" class="submit" value="我要咨询" @click="apply"> -->
          <p>*请你准确填写完整信息，后续会有招生老师与您联系。<br/>以上信息将严格保密，仅用于中欧课程咨询。</p>
      </div>
      <!-- <div v-show="loading" class="loading">
        <img :src="images.loading" alt="" class="loading-img"/>
      </div> -->
  </div>
</template>

<script>
import images from '@/utils/images.js'
import request from '@/utils/request.js'
import md5 from 'md5';
export default {
    data () {
        window.form = this
        return {
            images: images,
            name: '',
            phone: '',
            email: '',
            company: '',
            title: '',
            applying: false,
            loading: false
        }
    },
    computed: {
        disabled() {
            return !(this.name && this.phone && this.email && this.company && this.title)
        }
    },
    methods: {
        error(msg) {
            this.$toast.fail(msg)
        },
        getTimestamp() {
            return parseInt(Date.now() / 1000);
        },
        getMD5(str) {
            return md5(str);
        },
        apply() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            let error = "";
            const mailRegex = new RegExp(
                /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
            );

            if (
                !this.name ||
                !this.phone ||
                !this.email ||
                !this.company ||
                !this.title
            ) {
                error = '信息不完整!';
            } else if (!mailRegex.test(this.email)) {
                error = '邮箱格式错误!';
            }
            console.log(error)
            if (error) {
                this.error(error)
                this.loading = false
                return;
            }

            const bodyData = {
                name: this.name,
                phone: this.phone,
                email: this.email,
                company: this.company,
                jobTitle: this.title,
                // createDate: '',
                // channel: '',
                cousultCourse: 'FMBA',
                sourceDept: 'FMBA'
            };

            // const query = this.$route.query
            // let source = sessionStorage.getItem("source");
            // source = (source && JSON.parse(source)) || {};

            // bodyData.source = query.utm_source || '';
            // bodyData.campaign = query.utm_campaign || '';
            // bodyData.medium = query.utm_medium || '';

            const timestamp = this.getTimestamp();
            const sign = this.getMD5('ceibs' + timestamp);
            request({
                url: '/Ulec/receiveLeads',
                method: 'post',
                data: bodyData,
                headers: {
                    timestamp: timestamp,
                    sign: sign
                }
            }).then(res => {
                console.log(res)
                this.$toast.success('申请成功')
                this.loading = false
            }).catch(err => {  
                console.log(err)
                this.loading = false
                this.$toast.fail('系统错误，请稍后重试')
            })
            // this.$http
            //     .post("/api/api/application", bodyData)
            //     .then(result => {
            //     console.log(result.body);
            //     if (result.body.Status === 0) {
            //         this.dialogVisible = true;

            //         this.applied = false;
            //     } else {
            //         this.error = result.body.Message;

            //         this.applied = false;
            //         console.log(result.body.Message);
            //     }
            //     //            this.router.push('home')
            //     })
            //     .catch(result => {
            //     this.error = "Network Error";
            //     alert(this.error);
            //     });
            }
    }
}
</script>

<style lang="scss" scoped>
// .loading {
//   position: fixed;
//   left: 50%;
//   top: 50%;
//   transform: translate(-50%, -50%);
//   img {
//     width: 200px;
//   }
// }
.loading-img {
    width: 64px;
    vertical-align: -20px;
}
.form {
    position: relative;
    .form-content {
        position: absolute;
        top: 228px;
        width: 100%;
        padding: 30px;
        padding-top: 0;
        box-sizing: border-box;
        input, .input {
            width: 100%;
            font-size: 32px;
            line-height: 82px;
            height: 82px;
            border-radius: 8px;
            border: none;
            outline: none;
            padding-left: 22px;
            box-sizing: border-box;
        }
        input + input {
            margin-top: 12px;
        }
        .submit {
            margin-top: 50px;
            background: #A98057;
            color: #fff;
            &[disabled] {
                background: #e4e4e4;
            }
        }
        p {
            margin-top: 40px;
            font-size: 24px;
            color: #fff;
            line-height: 40px;
        }
    }
}
</style>